<template>
  <div id="supplier" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn color="primary" id="addBtn" @click="toAddPayable" label="添加应付帐款" icon="payment" />
        </div>
        <div class="col-md-3 col-11">
          <q-select filled v-model="queryForm.supplierId" :options="supplierList" option-label="supplierName"
            option-value="id" emit-value map-options label="供应商" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input filled dense v-model="queryForm.beginTime" label="开票开始日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm.beginTime" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input filled dense v-model="queryForm.endTime" label="开票结束日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm.endTime" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn label="重置" type="reset" color="primary" flat class="q-ml-sm" />
        </div>
      </div>
    </q-form>

    <q-table ref="mytable" title="应付帐款信息" :data="tableData.list" :columns="columns" row-key="id"
      :pagination.sync="pagination" :loading="loading" @request="request" binary-state-sort separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]">
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn round color="primary" size="xs" icon="edit" @click="handleEdit(props.rowIndex, props.row)" />
            <q-btn round color="deep-orange" size="xs" icon="delete_forever" @click="handleRemove(props.row)" />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_TOTAL).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_AMOUNT_PAID).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_AMOUNT_BALANCE).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td> </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { list as listSupplier } from "@/api/erp/supplier";
import {
  list as listPayable,
  remove as removePayable,
} from "@/api/erp/finance/payable";
import numbro from "numbro";
export default {
  data() {
    return {
      numbro,
      options: [
        { value: "0", label: "未付款" },
        { value: "1", label: "部分付款" },
        { value: "2", label: "已结清" },
      ],
      supplierList: [],
      queryForm: {},
      tableData: {},
      loading: false,
      pagination: {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "supplierName",
          align: "center",
          label: "供应商名称",
          field: (row) => row.supplier.supplierName,
        },
        {
          name: "INVOICE_DATE",
          align: "center",
          label: "开票日期",
          field: "invoiceDate",
          sortable: true,
        },
        {
          name: "TOTAL",
          align: "center",
          label: "价税合计",
          field: (row) =>
            numbro(row.total || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "AMOUNT_PAID",
          align: "center",
          label: "已付金额",
          field: (row) =>
            numbro(row.amountPaid || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "AMOUNT_BALANCE",
          align: "center",
          label: "未付金额",
          field: (row) =>
            numbro(row.amountBalance || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "status",
          align: "center",
          label: "状态",
          field: (row) => row.status ? this.options[row.status].label : '',
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  methods: {
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    toAddPayable() {
      this.$router.push("/payable/detail");
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      } else {
        self.queryForm.orderBy = null;
      }
      listPayable(self.queryForm).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.tableData = response.data.data;
          self.pagination.rowsNumber = self.tableData.total;
          // don't forget to update local pagination object
          self.pagination.page = page;
          self.pagination.rowsPerPage = rowsPerPage;
          self.pagination.sortBy = sortBy;
          self.pagination.descending = descending;
          // ...and turn of loading indicator
          self.loading = false;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    listSupplier() {
      var self = this;
      listSupplier().then((response) => {
        if (response.data.errorCode == "00000") {
          self.supplierList = response.data.data.list;
        }
      });
    },
    handleEdit(rowIndex, row) {
      this.$router.push({ path: "/payable/detail", query: { id: row.id } });
    },
    handleRemove(row) {
      var self = this;
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该条记录, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          console.log(">>>> OK");
          removePayable(row.id).then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$q.notify({ type: "positive", message: "删除成功" });
              self.query();
            } else {
              self.$q.notify({
                type: "negative",
                message: response.data.errorMsg,
              });
            }
          });
        })
        .onCancel(() => {
          self.$q.notify({ type: "info", message: "已取消删除" });
        })
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
  },
  mounted: function () {
    this.listSupplier();
    this.query();
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}

#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>